import React from 'react'
import { motion } from 'motion/react'

const BUTTON_SPRING = { type: 'spring', stiffness: 400, damping: 20 } as const

interface RoundPlusButtonProps {
    onClick: () => void
    /** Tooltip and accessible name, e.g. "Add person". */
    label: string
    /** Turns the + into a × — for a + that opens a menu it then closes. */
    open?: boolean
    'aria-expanded'?: boolean
}

/**
 * The gold round + that starts something new on a page: the Checkins page's
 * action menu, and Add on the collection pages.
 */
const RoundPlusButton: React.FC<RoundPlusButtonProps> = ({ onClick, label, open = false, ...rest }) => (
    <motion.button
        type="button"
        onClick={onClick}
        whileHover={{ scale: 1.1 }}
        whileTap={{ scale: 0.9 }}
        transition={BUTTON_SPRING}
        className="p-2 rounded-full bg-action text-white hover:bg-action-dark focus:outline-none focus:ring-2 focus:ring-action cursor-pointer"
        title={label}
        aria-label={label}
        aria-expanded={rest['aria-expanded']}
    >
        <motion.svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-6 w-6"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            animate={{ rotate: open ? 45 : 0 }}
            transition={BUTTON_SPRING}
        >
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v16m8-8H4" />
        </motion.svg>
    </motion.button>
)

export default RoundPlusButton
